<template>
  <div class="dk--bot-messages" v-if="store.messages">
      <DkBotMessage :message="message" v-for="message in store.messages" :key="message.ID"></DkBotMessage>
  </div>
</template>

<script>
import { store } from "@/store";
import DkBotMessage from "@/components/DkBotMessage.vue";
import { nextTick } from 'vue';

export default {
  name: 'DkBotMessages',
  components: {
    DkBotMessage,
  },
  data() {
    return {
      store,
      minHeight: 0,
      fireNext: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize);

    /*const observer = new MutationObserver((mutationList, observer) => {
      console.log('mutation observer', { mutationList, observer });

      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          console.log("A child node has been added or removed.");
        } else if (mutation.type === "attributes") {
          console.log(`The ${mutation.attributeName} attribute was modified.`);
        }
      }

    });

    observer.observe(this.$el, { attributes: true, childList: true, subtree: true });*/

    /*let treshholds = [];

    for (let i = 0; i <= 1.0; i += 0.2) {
      treshholds.push(i);
    }

    const observer = new IntersectionObserver((a,b) => {
      console.log(a ,b, this.store.fireNextMsg);
      if (this.store.fireNextMsg !== null) {
        this.store.nextMessage(this.store.fireNextMsg, null, this.store.beforeNextMsgDelay);
      } else {
        console.log('this.store.fireNextMsg', this.store.fireNextMsg);
      }
    }, {
      //root: null,
      rootMargin: "30px",
      threshold: treshholds,
    });

    observer.observe(this.$el.parentNode.querySelector('.dk--bot-bottom'));*/
  },
  unmounted() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    onWindowResize() {
      this.setHeight(true);
    },

    async setHeight(makeSmaller = false) {
      await nextTick();

      if ((!makeSmaller && this.minHeight > this.$el.clientHeight) || this.$el.clientHeight < 1) {
        return;
      }

      this.minHeight = this.$el.clientHeight;

      this.$el.parentNode.style.minHeight = (this.$el.clientHeight + 10) + 'px';
      this.$el.parentNode.style.maxHeight = (this.$el.scrollHeight + 10) + 'px';
    },
    async scrollToBottom() {
      if (this.store.scrollTo === 'no-scroll') return;

      await nextTick();

      const messagesBottom = this.$el.getBoundingClientRect().bottom;

      if (messagesBottom + 10 > window.innerHeight) {
        const msg = (this.$el).querySelector('.dk--bot-msg-container:last-child');

        const toTopOrBottom = msg.scrollHeight > window.innerHeight ? 'top' : 'bottom';

        let scrollBy = toTopOrBottom === 'top'
            ? msg.getBoundingClientRect().top
            : messagesBottom - window.innerHeight + 50;

        //console.log('skrollaa ' + scrollBy + 'px, store.scrollTo = ' + this.store.scrollTo + ', toTopOrBottom = ' + toTopOrBottom);

        window.scrollBy({
          top: scrollBy,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  },
  watch: {
    'store.scrollTo'() {
      this.scrollToBottom();
    },
    store: {
      handler() {
        this.setHeight();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.dk--bot-messages {
  margin: 0;
  padding: 0;
  font-size: var(--dk--bot-msg-font-size);
  overflow: hidden;
  min-height: 200px;

  @media (min-width: 768px) {
    font-size: var(--dk--bot-msg-font-size--lg);
  }
}
</style>
